import React from 'react'
import { useState } from 'react'
import MySpiner from '../../../UI/spiner/MySpiner'
import { useEffect } from 'react'
import { responseError } from '../../../../helpers/response/ResponseHelper'
import { getSeriesGoodDataBySeriesScanAPI } from '../../../../api/pack/seriesAPI'

const PackingGoodGetSeriesData = ({ goodType, valueScan, goodsFromBd, setGoodsFromBd }) => {

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        getGoodDataByScan()
    }, [goodType, valueScan])

    const getGoodDataByScan = () => {
        setLoading(true)
        setError('')

        getSeriesGoodDataBySeriesScanAPI({
            goodType,
            scanData: valueScan,
            goodsFromBd // Решта відсканованих та отриманих товарів
        }).then(data => {
            setGoodsFromBd(data)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div>
        {
            loading ? <MySpiner /> : ''
        }

        {
            error ? 
                <div className='error'>
                    {error}
                </div>
            : ''
        }
    </div>
  )
}

export default PackingGoodGetSeriesData